import { FETCH_SHOOTING_DAY_PROPS } from "./actions";

const defaultState = {
  props: [],
  loading: true,
  readOnly: false,
  errors: null
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case FETCH_SHOOTING_DAY_PROPS + "_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case FETCH_SHOOTING_DAY_PROPS + "_FULFILLED": {
      return {
        ...state,
        props: action.payload.data.props,
        readOnly: action.payload.data.readOnly,
        loading: false,
        errors: null
      };
    }

    case FETCH_SHOOTING_DAY_PROPS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
